import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthRepository } from '@data/auth/auth.repository';
import { AlterarKmRepository } from '@data/alterar-km/alterar-km.repository';
import { ThemeRepository } from '@data/theme/theme.repository';
import { UsuarioRepository } from '@data/usuario/usuario.repository';
import { AtendimentoRepository } from '@data/atendimento/atendimento.repository';
import { MotivoAtendimentoRepository } from '@data/tipo-atendimento/motivo-atendimento.repository';
import { VeiculoRepository } from '@data/veiculo/veiculo.repository';
import { ContratoRepository } from '@data/contrato/contrato.repository';
import { MotivoSinistroRepository } from '@data/tipo-sinistro/tipo-sinistro.repository';
import { MunicipioRepository } from '@data/municipio/municipio.repository';
import { MultaRepository } from '@data/multas/multa.repository';
import { AnexoRepository } from '@data/anexo/anexo.repository';
import { CondutorRepository } from '@data/condutor/condutor.repository';
import { ContratoGrupoRepository } from '@data/contrato-grupo/contrato-grupo.repository';
import { ServicoExecutadoRepository } from '@data/servico-executado/servico-executado.repository';
import { FaturamentoRepository } from './faturamento/faturamento.repository';
import { PneuRepository } from './pneu/pneu.repository';
import { NotificacaoRepository } from './notificacao/notificacao.repository';
import { MedicaoRepository } from './medicoes/medicao.repository';
import { CategoriaCNHRepository } from './categoria-cnh/categoria-cnh.repository';
import { FornecedoresRepository } from './fornecedores/fornecedores.repository';
import { IndicadoresRepository } from './indicadores/indicadores.repository';
import { CepRepository } from './cep/cep.repository';
import { InspecaoRepository } from '@data/inspecoes/inspecao.repository';


@NgModule({
  declarations: [],
  imports: [CommonModule, HttpClientModule],
  providers: [
    AuthRepository,
    AlterarKmRepository,
    AnexoRepository,
    ThemeRepository,
    UsuarioRepository,
    AtendimentoRepository,
    FaturamentoRepository,
    FornecedoresRepository,
    MultaRepository,
    MotivoAtendimentoRepository,
    MotivoSinistroRepository,
    MunicipioRepository,
    VeiculoRepository,
    ContratoRepository,
    CondutorRepository,
    ContratoGrupoRepository,
    ServicoExecutadoRepository,
    PneuRepository,
    NotificacaoRepository,
    MedicaoRepository,
    CategoriaCNHRepository,
    IndicadoresRepository,
    CepRepository,
    InspecaoRepository,
  ],
})
export class DataModule { }
